import React from "react";
import { Spinner } from "reactstrap";
import clsx from 'clsx';
import Swal, { SweetAlertIcon } from 'sweetalert2';

interface HelpInfoProps {
  infos: string[];
  className?: string;
}

const HelpInfo = ({ infos, className }: HelpInfoProps) => {
  const CustomAlert = (message: string, type: SweetAlertIcon = 'question') => {
    if (message) message = (message + '').replaceAll("\n", "<br/>");
    const html = `<div style="text-align:left">${message}</div>`;
    return Swal.fire({
      html: html,
      // text: message,
      icon: type,
      confirmButtonText: 'OK',
      customClass: {
        icon: "swal-small-icon"
      }
    });
  };

  const showInfo = () => {
    CustomAlert('- ' + infos.join("<br/>- "));
  }
  return (
    <i className={clsx('fas fa-question-circle hand text-info ps-1 pe-1', className)} onClick={showInfo}></i>
  );
};

export default HelpInfo;
